import { render, staticRenderFns } from "./SocialCommentsSection.vue?vue&type=template&id=cbe13522&"
import script from "./SocialCommentsSection.vue?vue&type=script&lang=js&"
export * from "./SocialCommentsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports